export const hieuLuc = { label: "Hiệu lực", value: "Y" };
export const khongHieuLuc = { label: "Không hiệu lực", value: "N" };
export const enableds = [hieuLuc, khongHieuLuc];
